
import Vue from "vue";
import { Component } from "vue-property-decorator";

import Titlebar from "./Titlebar.vue";
import BlankSidebarContent from "./BlankSidebarContent.vue";
import TabsAndControls from "./TabsAndControls.vue";
import { uiStore } from "@/store/store";

@Component({
  components: {
    Titlebar,
    TabsAndControls,
    BlankSidebarContent
  }
})
export default class ElementPropertiesPanel extends Vue {
  get elementIsActive() {
    return !!uiStore.activeElement;
  }
}
